<template>
  <div class="s-coming-soon s-coming-soon--stand-alone">
    <slot
      name="card"
      :open="open"
      :close="close"
      :toggle="toggle"
      :is-opened="isOpened"></slot>
    <slot
      name="notify"
      :open="open"
      :close="close"
      :toggle="toggle"
      :is-opened="isOpened"></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpened: false,
    }
  },
  methods: {
    open() {
      this.isOpened = true
    },
    close() {
      this.isOpened = false
    },
    toggle() {
      this.isOpened = !this.isOpened
    },
  },
}
</script>
